export type DataSource = 'demo' | 'supabase';

/** Test builds select their source from the URL, never an invisible browser preference. */
export function resolveDataSource({
  switchEnabled,
  search = '',
}: {
  switchEnabled: boolean;
  search?: string;
}): DataSource {
  if (switchEnabled) {
    const params = new URLSearchParams(search);
    // Auth callbacks and explicit live links take priority over any demo parameter.
    if (params.has('live') || params.get('source') === 'supabase') return 'supabase';
    if (params.has('demo')) return 'demo';
    const requested = params.get('source');
    if (requested === 'demo' || requested === 'supabase') return requested;
  }
  return 'supabase';
}

/** Keep demo visible in the URL through SPA navigation and refresh without dropping filters. */
export function withDemoSearch(search: string): string {
  if (new URLSearchParams(search).has('demo')) return search;
  return `${search || '?'}${search ? '&' : ''}demo`;
}

/** Explicit mode switches replace conflicting mode flags and retain the current page. */
export function dataSourceUrl(href: string, source: DataSource): string {
  const url = new URL(href);
  for (const key of ['demo', 'live', 'source']) url.searchParams.delete(key);
  url.searchParams.set(source === 'demo' ? 'demo' : 'live', '');
  return url.href;
}
